var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActivities = function SvgActivities(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      boxShadow: "0 0 7px #ccc",
      borderRadius: 10,
      margin: 10
    },
    viewBox: "0 0 52 52"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "#fff",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1F4970",
    d: "M11.405 29.148h1.454v6.75h-1.454z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F4970",
    d: "M39.626 23.568a4.3 4.3 0 0 0 1.553-3.31v-1.933c0-2.384-1.953-4.325-4.354-4.325s-4.354 1.94-4.354 4.325v1.934c0 1.326.605 2.515 1.554 3.31a4.69 4.69 0 0 0-3.804 2.423 4.7 4.7 0 0 0-1.419-.323 4.3 4.3 0 0 0 1.552-3.308v-1.933c0-2.385-1.953-4.326-4.354-4.326s-4.354 1.94-4.354 4.326v1.933c0 1.326.603 2.514 1.552 3.308a4.7 4.7 0 0 0-1.42.323 4.69 4.69 0 0 0-3.803-2.424 4.3 4.3 0 0 0 1.554-3.31v-1.933c0-2.384-1.953-4.325-4.354-4.325s-4.354 1.94-4.354 4.325v1.934c0 1.326.604 2.515 1.554 3.309C9.935 23.734 8 25.76 8 28.226v7.503h1.455v-7.503c0-1.778 1.456-3.224 3.245-3.224h4.948c1.228 0 2.33.678 2.88 1.73a4.65 4.65 0 0 0-1.703 3.595v7.506h1.455v-7.506c0-1.778 1.456-3.225 3.246-3.225h4.948c1.79 0 3.247 1.447 3.247 3.225v7.506h1.454v-7.506a4.65 4.65 0 0 0-1.703-3.594 3.24 3.24 0 0 1 2.88-1.731H39.3c1.79 0 3.246 1.446 3.246 3.224v7.503H44v-7.503c0-2.466-1.934-4.491-4.375-4.658m-27.35-5.243c0-1.588 1.3-2.88 2.899-2.88s2.9 1.292 2.9 2.88v1.934c0 1.588-1.301 2.88-2.9 2.88s-2.9-1.292-2.9-2.88zM23.1 20.428c0-1.589 1.3-2.881 2.9-2.881 1.598 0 2.899 1.292 2.899 2.88v1.934c0 1.588-1.301 2.88-2.9 2.88s-2.9-1.292-2.9-2.88zm10.825-2.103c0-1.588 1.3-2.88 2.9-2.88 1.598 0 2.899 1.292 2.899 2.88v1.934c0 1.588-1.301 2.88-2.9 2.88s-2.9-1.292-2.9-2.88z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F4970",
    d: "M39.142 29.148h1.454v6.75h-1.454zM29.258 31.25h1.454V38h-1.454zM21.288 31.25h1.454V38h-1.454z"
  })));
};
export default SvgActivities;